import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import autobind from 'autobind-decorator';
import styled from '@emotion/styled';
import { TranslationSourceStore } from '@seedlang/stores';
import { Link } from 'react-router';
import Grid from 'components/layout/grid';

const Wrapper = styled.div`

`;

@observer
class TranslationSourceEdit extends React.Component {

  constructor(props) {
    super(props);
    TranslationSourceStore.getShow({ids: {translationSourceId: this.props.params.translationSourceId}}, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    TranslationSourceStore.setShowData(resp);
  }

  render() {
    return (
      <Wrapper>
        {
          TranslationSourceStore.hasShowData &&
            <div>
              <Grid columns={2} gap='sm'>
                <fieldset>
                  <legend>Source</legend>
                  <Link
                    to={{name: 'builder.sources.edit', params: {sourceId: TranslationSourceStore.showData.source.id}}}
                  >
                    <i className='fa fa-chevron-right fa-block' style={{marginRight: 10}} />
                  </Link>
                  {TranslationSourceStore.showData.source.text}
                </fieldset>
                <fieldset>
                  <legend>Translation</legend>
                  <Link
                    to={{name: 'builder.words.edit', params: {wordId:TranslationSourceStore.showData.translation.id}}}
                  >
                    {TranslationSourceStore.showData.translation.targetText}
                  </Link>
                </fieldset>
              </Grid>
            </div>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(TranslationSourceEdit);
